import RichText from "@components/common/RichText";
import Section from "@components/common/Section";
import { FC } from "react";

interface RichTextV2Props {
  data: {
    content?: string | null;
  };
}

const RichTextV2: FC<RichTextV2Props> = ({ data }) => {
  return (
    <Section section={data} className="my-[120px]">
      <RichText>{data.content}</RichText>
    </Section>
  );
};

export const RichTextV2Article: FC<RichTextV2Props> = ({ data }) => {
  return <RichText className="my-3m">{data.content}</RichText>;
};

export default RichTextV2;
